import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { DefaultLayout } from "../../layouts/Default";
import { TopNavigation } from "../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../themes/Default/components/TopNavigation/components/Button";
import { Slide, toast, ToastContainer } from "react-toastify";
import { Tabs } from "../../themes/Default/components/Tabs";
import { Main } from "../../themes/Default/components/Main";
import { Title } from "../../themes/Default/components/Title";
import { Breadcrumps } from "../../themes/Default/components/Breadcrumps";
import { Link } from "../../themes/Default/components/Breadcrumps/components/Link";
import { Formik } from "formik";
import { Form } from "../../themes/Default/components/Form";
import { Row } from "../../themes/Default/components/Form/components/Row";
import { Field } from "../../themes/Default/components/Form/components/Row/components/Field";
import { Textarea } from "../../themes/Default/components/Form/components/Textarea";
import { Toaster } from "../../themes/Default/components/Toaster";
import { employeesManagement } from "../../hooks/api/EmployeesManagement";

const ArchiveNote = () => {
    const { t } = useTranslation("common");
    const { employeeId } = useParams();
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState([]);
    const { useArchiveEmployeeMutation, useViewEmployeeMutation } = employeesManagement;
    const [canArchiveGroup] = useState(true);
    const [employeeName, setEmployeeName] = useState("");

    const [employeeArchive] = useArchiveEmployeeMutation();
    const [viewEmployee] = useViewEmployeeMutation();
    
    const gotoNotesTab = (employeeId) => {
        navigate("/employees/" + employeeId + "/notes");
    };

    const gotoDocumentsTab = (employeeId) => {
        navigate("/employees/" + employeeId + "/documents");
    };

    const tabs = [
        { title: t("details"), isActive: true },
        { title: t("documents"), onClick: () => gotoDocumentsTab(employeeId) },
        { title: t("notes"), onClick: () => gotoNotesTab(employeeId) },
    ];

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onArchive = (values) => {
        toast.warn(
            ({ closeToast }) => (
                <Toaster
                    closeToast={closeToast}
                    description={t("employees.confirmArchive")}
                    optionNo={t("no")}
                    optionYes={t("yes")}
                    onClick={() => {
                        closeToast();
                        const body = {
                            ...values,
                        }; 
                        employeeArchive({ employeeId, body }).then((result) => {
                            if (result?.error) {
                                setFormErrors(result?.error?.data?.error?.violations);
                                toast.error(result.error.data.error.responseMessage);
                            } else {
                                navigate("/employees/edit/" + employeeId);
                            }
                        });
                    }}
                />
            ),
            {
                autoClose: false,
                progress: false,
                closeButton: false,
            },
        );
    };

    useEffect(() => {
        viewEmployee(employeeId).then((result) => {
            setEmployeeName(result?.data?.firstName + ' ' + result?.data?.lastName);
        });
    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to={"/employees/edit/" + employeeId} />
                <Button title={t("employees.archiveEmployee")} icon="fa-regular fa-box-archive" onClick={onSave} isDisabled={!canArchiveGroup}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>{employeeName}</Title>
                <Breadcrumps>
                    <Link title={t("employees.title")} icon="fa-user-tie" />
                    <Link title={t("details")} />
                    <Link title={t("employees.archiveEmployee")} isActive={true} />
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{
                        note: "",
                    }}
                    onSubmit={onArchive}
                >
                    {({ values, handleChange, setFieldValue }) => (
                        <Form>
                            <Row>
                                <Field isFullWidth={true}>
                                    <Textarea
                                        rows={6}
                                        name="note"
                                        label={t("groups.reasonForArchiving")}
                                        value={values.note}
                                        onChange={handleChange}
                                        error={formErrors?.note}
                                    />
                                </Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default ArchiveNote;